import { useEffect, useRef, useState } from "react";

const row1Images = [
  "https://public.readdy.ai/ai/img_res/d96b3129114202f5e7175bb1012d53f3.jpg",
  "https://readdy.ai/api/search-image?query=cute%20japanese%20girl%20looking%20straight%20at%20camera%20portrait%20pastel%20background%20soft%20lighting%20natural%20beauty%20warm%20smile%20dark%20hair%20casual%20fashion%20vibrant%20skin%20high%20quality&width=160&height=200&seq=h1b&orientation=portrait",
  "https://readdy.ai/api/search-image?query=attractive%20japanese%20woman%20front%20facing%20portrait%20light%20pink%20background%20studio%20photo%20bright%20eyes%20gentle%20smile%20straight%20black%20hair%20elegant%20look%20high%20resolution&width=160&height=200&seq=h1c&orientation=portrait",
  "https://readdy.ai/api/search-image?query=young%20japanese%20woman%20smiling%20directly%20at%20camera%20clean%20background%20soft%20natural%20light%20pretty%20face%20dark%20hair%20casual%20outfit%20fresh%20look%20portrait%20photo&width=160&height=200&seq=h1d&orientation=portrait",
  "https://readdy.ai/api/search-image?query=japanese%20girl%20portrait%20facing%20forward%20warm%20smile%20light%20background%20studio%20lighting%20natural%20makeup%20black%20hair%20youthful%20vibrant%20beautiful%20high%20quality%20photo&width=160&height=200&seq=h1e&orientation=portrait",
  "https://readdy.ai/api/search-image?query=pretty%20japanese%20woman%20looking%20at%20camera%20soft%20background%20natural%20light%20portrait%20cheerful%20expression%20long%20hair%20elegant%20style%20clear%20skin%20high%20quality&width=160&height=200&seq=h1f&orientation=portrait",
  "https://readdy.ai/api/search-image?query=japanese%20woman%20front%20facing%20portrait%20smiling%20bright%20background%20studio%20light%20natural%20beauty%20dark%20hair%20casual%20fashion%20warm%20expression%20high%20resolution%20photo&width=160&height=200&seq=h1g&orientation=portrait",
];

const row2Images = [
  "https://readdy.ai/api/search-image?query=beautiful%20japanese%20woman%20portrait%20facing%20camera%20soft%20pink%20background%20studio%20lighting%20natural%20makeup%20long%20black%20hair%20warm%20smile%20elegant%20high%20quality%20photo&width=160&height=200&seq=h2a&orientation=portrait",
  "https://readdy.ai/api/search-image?query=cute%20japanese%20girl%20smiling%20at%20camera%20light%20background%20soft%20studio%20light%20natural%20beauty%20dark%20hair%20casual%20style%20fresh%20face%20portrait%20high%20quality&width=160&height=200&seq=h2b&orientation=portrait",
  "https://readdy.ai/api/search-image?query=attractive%20young%20japanese%20woman%20looking%20forward%20portrait%20clean%20background%20bright%20lighting%20pretty%20smile%20black%20hair%20elegant%20fashion%20clear%20skin%20high%20resolution&width=160&height=200&seq=h2c&orientation=portrait",
  "https://readdy.ai/api/search-image?query=japanese%20woman%20front%20facing%20portrait%20cheerful%20expression%20soft%20background%20natural%20light%20beautiful%20face%20long%20hair%20casual%20outfit%20vibrant%20high%20quality%20photo&width=160&height=200&seq=h2d&orientation=portrait",
  "https://readdy.ai/api/search-image?query=young%20japanese%20girl%20smiling%20directly%20at%20camera%20pastel%20background%20studio%20lighting%20natural%20makeup%20dark%20hair%20youthful%20fresh%20look%20portrait%20high%20quality&width=160&height=200&seq=h2e&orientation=portrait",
  "https://readdy.ai/api/search-image?query=pretty%20japanese%20woman%20portrait%20facing%20forward%20warm%20smile%20light%20studio%20background%20natural%20beauty%20black%20hair%20elegant%20style%20clear%20skin%20high%20resolution&width=160&height=200&seq=h2f&orientation=portrait",
  "https://readdy.ai/api/search-image?query=japanese%20woman%20looking%20at%20camera%20soft%20background%20studio%20light%20natural%20makeup%20long%20dark%20hair%20cheerful%20expression%20casual%20fashion%20vibrant%20high%20quality%20photo&width=160&height=200&seq=h2g&orientation=portrait",
];

const row3Images = [
  "https://readdy.ai/api/search-image?query=beautiful%20japanese%20girl%20front%20facing%20portrait%20clean%20white%20background%20soft%20lighting%20natural%20beauty%20dark%20hair%20warm%20smile%20elegant%20look%20high%20quality%20photo&width=160&height=200&seq=h3a&orientation=portrait",
  "https://readdy.ai/api/search-image?query=cute%20japanese%20woman%20smiling%20at%20camera%20pastel%20background%20studio%20lighting%20natural%20makeup%20long%20black%20hair%20youthful%20fresh%20portrait%20high%20quality&width=160&height=200&seq=h3b&orientation=portrait",
  "https://readdy.ai/api/search-image?query=attractive%20japanese%20girl%20looking%20forward%20portrait%20soft%20pink%20background%20bright%20studio%20light%20pretty%20face%20dark%20hair%20casual%20style%20clear%20skin%20high%20resolution&width=160&height=200&seq=h3c&orientation=portrait",
  "https://readdy.ai/api/search-image?query=young%20japanese%20woman%20front%20facing%20portrait%20cheerful%20smile%20light%20background%20natural%20light%20beautiful%20face%20long%20hair%20elegant%20outfit%20vibrant%20high%20quality%20photo&width=160&height=200&seq=h3d&orientation=portrait",
  "https://readdy.ai/api/search-image?query=japanese%20girl%20smiling%20directly%20at%20camera%20clean%20background%20soft%20studio%20lighting%20natural%20makeup%20black%20hair%20fresh%20look%20portrait%20high%20quality%20photo&width=160&height=200&seq=h3e&orientation=portrait",
  "https://readdy.ai/api/search-image?query=pretty%20japanese%20woman%20looking%20at%20camera%20warm%20smile%20light%20studio%20background%20natural%20beauty%20dark%20hair%20casual%20fashion%20clear%20skin%20high%20resolution%20portrait&width=160&height=200&seq=h3f&orientation=portrait",
  "https://readdy.ai/api/search-image?query=japanese%20woman%20portrait%20facing%20forward%20soft%20background%20studio%20light%20natural%20makeup%20long%20black%20hair%20cheerful%20expression%20elegant%20style%20vibrant%20high%20quality&width=160&height=200&seq=h3g&orientation=portrait",
];

function MarqueeRow({ images, speed = 30, reverse = false }: { images: string[]; speed?: number; reverse?: boolean }) {
  const doubled = [...images, ...images];
  return (
    <div className="overflow-hidden w-full">
      <div
        className="flex gap-2"
        style={{
          animation: `marquee-scroll ${speed}s linear infinite ${reverse ? "reverse" : "normal"}`,
          width: "max-content",
        }}
      >
        {doubled.map((src, i) => (
          <div
            key={i}
            className="flex-shrink-0 w-[120px] h-[160px] rounded-xl overflow-hidden"
          >
            <img
              src={src}
              alt={`女性プロフィール${i + 1}`}
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function HeroBanner() {
  const [lastUpdateDate, setLastUpdateDate] = useState("");

  useEffect(() => {
    // 前日の日付を取得
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    
    const year = yesterday.getFullYear();
    const month = yesterday.getMonth() + 1;
    const day = yesterday.getDate();
    
    setLastUpdateDate(`${year}年${month}月${day}日`);
  }, []);

  return (
    <section id="top" className="relative w-full h-[520px] overflow-hidden bg-gray-900">
      {/* Scrolling image rows background */}
      <div className="absolute inset-0 w-full h-full flex flex-col justify-between py-2 gap-2">
        <MarqueeRow images={row1Images} speed={28} />
        <MarqueeRow images={row2Images} speed={22} reverse />
        <MarqueeRow images={row3Images} speed={26} />
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

      {/* Hero text content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center w-full">
        <div className="mb-4">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-xs font-medium px-4 py-1.5 rounded-full border border-white/30">
            秒速マッチングアプリ紹介サイト
          </span>
        </div>

        <h1 className="text-3xl font-bold text-white mb-3 leading-tight drop-shadow-lg">
          あなたにぴったりの<br />女の子が絶対見つかる
        </h1>

        <p className="text-white/90 text-sm mb-8 leading-relaxed max-w-xs drop-shadow">
          厳選されたマッチングアプリを<br />徹底比較＆レビュー
        </p>

        <a
          href="#apps"
          className="bg-rose-500 text-white px-8 py-3.5 rounded-full font-medium shadow-lg hover:bg-rose-600 transition-colors whitespace-nowrap cursor-pointer text-sm flex items-center gap-2"
        >
          おすすめアプリを見る
          <i className="ri-arrow-down-line"></i>
        </a>
      </div>

      {/* 更新日表示 */}
      <div className="absolute bottom-4 right-4 z-10">
        <div className="bg-black/40 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-lg border border-white/20">
          最終更新日：{lastUpdateDate}
        </div>
      </div>

      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
